export default "__VITE_ASSET__3c18ba9c__"